import { useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import Booking from '../components/Booking';
import { useLegacyApi } from '../../../routes/legacyApiHook';
import { RootState } from '../../../config/redux/types';
import bookingData from '../static/bookingData';
import { BOOKING } from '../../../routes/config/pageTypes';
import useTrackEcommerce from '../../../features/tracking/useTrackEcommerce';
import { BookingState } from '../../../routes/reducers/types';
import { TrackProductItem } from '../../../features/tracking/types';

function buildTrackingIdentifier(
  lang: string | undefined,
  booking: BookingState | undefined,
): string | null {
  if (
    lang == null ||
    booking == null ||
    booking.accommodation_id == null ||
    booking.amount == null
  ) {
    return null;
  }
  return [lang, booking.accommodation_id, booking.amount].join('-');
}

function buildTrackingItems(booking?: BookingState): TrackProductItem[] | null {
  if (!booking || !booking.accommodation_id || !booking.object_name) {
    return null;
  }
  return [
    {
      id: booking.accommodation_id.toString(),
      item_id: booking.accommodation_id.toString(),
      name: booking.object_name,
      item_name: booking.object_name,
      quantity: 1,
      price: booking.amount,
    },
  ];
}

export default function BookingContainer(props: any): JSX.Element {
  const { lang } = useParams<'lang'>();
  const { processing, routes } = useSelector((state: RootState) => state);

  useLegacyApi(undefined, BOOKING);

  const { booking } = routes;

  useTrackEcommerce(
    { event: 'begin_checkout', items: buildTrackingItems(booking) },
    buildTrackingIdentifier(lang, booking),
  );

  if (!routes.booking || processing.accommodation_id < 0) {
    return <Booking {...props} />;
  }

  return <Booking {...props} {...routes.booking} {...processing} {...bookingData()} />;
}
